import { Image, Page, Text, View } from "@react-pdf/renderer";
import React from "react";

import "../fonts";

const FRONT_COVER_SRC = "/assets/facility-report/facility_report_front.png";
const BACK_COVER_SRC = "/assets/facility-report/facilty_report_back.png";

// Native pixel dimensions of the cover artwork
const COVER_IMAGE_WIDTH = 1365;
const COVER_IMAGE_HEIGHT = 1023;
// PDF points: 1pt = 1/72 inch, screen pixels at 96dpi → 1px = 0.75pt
const PX_TO_PT = 0.75;
const NATIVE_PAGE_SIZE: [number, number] = [
  COVER_IMAGE_WIDTH * PX_TO_PT,
  COVER_IMAGE_HEIGHT * PX_TO_PT,
];
const A4_LANDSCAPE_SIZE: [number, number] = [841.89, 595.28];

export type CoverPageSize = "native" | "a4-landscape";

const getPageSize = (pageSize: CoverPageSize): [number, number] =>
  pageSize === "a4-landscape" ? A4_LANDSCAPE_SIZE : NATIVE_PAGE_SIZE;

// Banner metrics tuned against the native page height; scaled down for the
// shorter A4 landscape page so the banner keeps the same proportions
// relative to the underlying artwork.
const getBannerScale = (pageSize: CoverPageSize) =>
  pageSize === "a4-landscape"
    ? A4_LANDSCAPE_SIZE[1] / NATIVE_PAGE_SIZE[1]
    : 1;

interface IFrontCoverPageProps {
  facilityName: string;
  honorificSuffix: string;
  pageSize: CoverPageSize;
}

export const FrontCoverPage: React.FunctionComponent<IFrontCoverPageProps> = ({
  facilityName,
  honorificSuffix,
  pageSize,
}) => {
  const scale = getBannerScale(pageSize);
  const facilityNameLabel = honorificSuffix
    ? `${facilityName}　${honorificSuffix}`
    : facilityName;

  return (
    <Page size={getPageSize(pageSize)}>
      <View style={{ position: "relative", width: "100%", height: "100%" }}>
        <Image
          src={FRONT_COVER_SRC}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
        <View
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            top: "63%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              maxWidth: "85%",
              backgroundColor: "#000000",
              paddingVertical: 16 * scale,
              paddingHorizontal: 36 * scale,
              transform: "rotate(-12deg)",
            }}
          >
            <Text
              style={{
                fontFamily: "NotoSansJP",
                fontWeight: 700,
                fontSize: 24 * scale,
                color: "#ffffff",
                textAlign: "center",
              }}
            >
              {facilityNameLabel}
            </Text>
          </View>
        </View>
      </View>
    </Page>
  );
};

interface IBackCoverPageProps {
  pageSize: CoverPageSize;
}

export const BackCoverPage: React.FunctionComponent<IBackCoverPageProps> = ({
  pageSize,
}) => (
  <Page size={getPageSize(pageSize)}>
    <Image
      src={BACK_COVER_SRC}
      style={{ width: "100%", height: "100%", objectFit: "contain" }}
    />
  </Page>
);
